import { makeStyles } from '@mui/styles';
import {
  BooleanFieldProps,
  FunctionField,
  FunctionFieldProps,
} from 'react-admin';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { resolvePath } from '@components/fields/resolve-path';

const useStyles = makeStyles({
  box: {
    textAlign: 'center',
  },
  checked: {
    fontSize: '24px',
    color: 'rgb(136, 210, 86)',
  },
  unchecked: {
    fontSize: '24px',
    color: 'rgb(253, 73, 45)',
  },
});

interface Props extends BooleanFieldProps {
  width?: number;
}

export const CheckboxField = (props: Partial<FunctionFieldProps> & Props) => {
  const cls = useStyles();
  const { width, ...restProps } = props;

  return (
    <FunctionField
      {...restProps}
      width={width}
      render={(record: any) => {
        const isChecked = resolvePath(record, props.source || '');

        return (
          <div className={cls.box} style={{ width: props.width }}>
            {isChecked === false
              ? <CloseCircleOutlined className={cls.unchecked} />
              : isChecked === true
                ? <CheckCircleOutlined className={cls.checked} />
                : null
            }
          </div>
        );
      }}
    />
  );
};
